import { pickBy } from '@/utils'
export default {
  name: 'search',
  setting: [
    { label: '釘在頂部', key: 'fixTop', component: 'switch', value: false },
    { label: '組件間距', key: 'padded', component: 'switch', value: true },
    { label: '占位內容', key: 'placeholder', component: 'input', value: '搜尋想要的商品' }
  ],
  transformIn: (v) => {
    const { name, base, config } = v
    return {
      name,
      ...base,
      ...config
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          padded: 'padded'
        })
      },
      config: (v) => {
        return pickBy(v, {
          fixTop: 'fixTop',
          placeholder: 'placeholder'
        })
      }
    })
  }
}
